import styled from '@emotion/styled'
import { theme } from 'flipper-ui/theme'

const { gray, neutral } = theme.colors

export const SidebarMainList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 2px;
    padding: 8px 0 0 0;
`

export const SidebarLogo = styled.img`
    cursor: pointer;
    height: 36px;
    max-width: 100%;
    object-fit: contain;
`

export const AppBarV2Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    height: 56px;
    padding: 10px 16px;
    background-color: ${neutral[50]};
    border-bottom: 1px solid ${gray[300]};
    box-sizing: border-box;
`

export const LayoutV2Root = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100vh;
    overflow: hidden;
`

export const LayoutV2RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`

export const LayoutV2ContentArea = styled.div`
    flex: 1;
    min-height: 0;
    overflow: auto;

    & #page-subheader {
        top: 0;
        background: ${neutral[50]};
    }
`
